import {
  Module,
  VuexModule,
  Mutation,
  getModule,
  Action,
} from "vuex-module-decorators";
import {
  SubscriptionTrial,
  UserDetails,
  UserDetailsResponse,
  userRole,
} from "models";
import store from "@/store";
import { Storage } from "@/helpers";
import router from "@/router";
import { subscription } from "subscriptionModels";

@Module({
  dynamic: true,
  namespaced: true,
  name: "Subscription",
  store,
})
class Subscription extends VuexModule {
  currentSubscription: subscription | null = null;
  currentTrial: SubscriptionTrial | null = null;
  packages: subscription[] = [];

  get getPackages() {
    return this.packages;
  }
  @Mutation
  setPackages(val: subscription[]) {
    this.packages = val;
  }
  @Mutation
  setTrial(val: SubscriptionTrial | null) {
    this.currentTrial = val;
  }
  get getTrial() {
    return this.currentTrial;
  }

  get getSubscription() {
    return this.currentSubscription;
  }
  @Mutation
  setSubscription(val: subscription | null) {
    this.currentSubscription = val;
  }
}
export default getModule(Subscription);
